module.exports = __webpack_public_path__ + "img/use-your-own-video.f04008fa.png";